
<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="fromdata">
      <el-form-item :label="dataobjs.lanmuming" prop="title" style="width:50%">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjs.lanmumingyingwen" prop="title_en" style="width:50%">
        <el-input v-model="ruleForm.title_en"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjs.fangwenlujing" prop="path" style="width:50%">
        <el-input v-model="ruleForm.path"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjs.xianshiyangshi" style="width:50%">
        <el-input v-model="ruleForm.icon"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjs.yonghuquanxianleixing" style="width:50%" class="lablets">
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="(city,index) in cities" :label="''+index" :key="index">{{city}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item :label="dataobjs.shangjilanmu" style="width:50%">
        <!-- <el-input v-model="ruleForm.parentid"></el-input> -->
        <el-select v-model="ruleForm.parentid" placeholder="请选择" style="width:100%">
            <el-option key="0" label="根目录" value="0"></el-option>
          <el-option v-for="item in optiones" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div style="text-align: center;" class="btenEtiel">
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleHide">{{dataobjs.quxiao}}</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">{{dataobjs.queding}}</el-button>
      </span>
    </div>
  </div>
</template>

<script>
import { Authupdatedata } from "@/network/index";
const cityOptions = ["平台", "经销商", "客户"];
export default {
  props: {
    optiones: {
      type: Array,
      default: []
    },
    ruleForm: {
      type: Object,
      default: {}
    },
    hidechide: {
      type: Function,
      default() {
        return Function;
      },
     
    },
    dataobjs:{
      type:Object,
      default:{}
    },
     navleftnew: {
        type: Function,
        default() {
          return Function;
        }
      },
      userList:{
        type:Function,
        default(){
          return Function
        }
      }
  },
  data() {
    return {
      cities: cityOptions,
      checkedCities: [],

      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        title_en: [
          { required: true, message: "请输入英文名称", trigger: "blur" }
        ],
        path: [{ required: true, message: "请输入路径", trigger: "blur" }]
      }
    };
  },
  created() {},
  mounted() {},
  methods: {
    dialogVisibleHide() {
    
      this.checkedCities = []
      // this.ruleForm = {}
        this.hidechide();
    },
    handleCheckedCitiesChange() {},
    submitForm(formName) {
      
      if (this.checkedCities.length == 0) {
        this.ruleForm.roletype = 0;
      } else {
        let checkbox = this.checkedCities;
        this.ruleForm.roletype = checkbox.join(",");
      }

      this.$refs[formName].validate(async valid => {
        if (valid) {
          // console.log('111');
          const { code, msg } = await Authupdatedata(this.ruleForm);
          // console.log(res);
          if (code) {
            this.$message.success(msg);
            this.hidechide();
            this.navleftnew()
            this.userList()
            this.$store.commit('supperData',new Date())
            this.$refs[formName].resetFields();
            this.checkedCities = []

          } else {
            this.$message.error(msg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style>
.fromdata {
  display: flex;
  flex-wrap: wrap;
}
.lablets .el-checkbox {
  margin-right: 5px !important;
}
</style>
